import type { AppVueRouter } from '@modules/core/services/router/types';
import {
  ADMIN_ARTICLES_ROUTE_NAME,
  ARTICLES_PERMISSIONS,
} from '@modules/articles/constants';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  ADMIN_ARTICLES_CREATE_ROUTE_NAME,
  ADMIN_ARTICLES_EDIT_ROUTE_NAME,
} from './constants';

export class ArticlesEditModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_ARTICLES_ROUTE_NAME, {
      name: ADMIN_ARTICLES_EDIT_ROUTE_NAME,
      path: 'edit/:id',
      permission: ARTICLES_PERMISSIONS.SHOW,
      component: () => import('./pages/ArticlesEditPage/ArticlesEditPage.vue'),
    });

    router.addChildRoute(ADMIN_ARTICLES_ROUTE_NAME, {
      name: ADMIN_ARTICLES_CREATE_ROUTE_NAME,
      path: 'create',
      permission: ARTICLES_PERMISSIONS.SHOW,
      component: () => import('./pages/ArticlesEditPage/ArticlesEditPage.vue'),
    });
  }

  addMenu(): void {
  }

  addTranslationKeys(): void {
  }
}
